import { BackstageOverrides } from '@backstage/core-components';
import { Theme } from '@mui/material/styles';
import { shellMetrics } from '../tokens';

export const styledMuiCardContent = (
  theme: Theme,
): BackstageOverrides['MuiCardContent'] => ({
  root: {
    minWidth: 0,
    padding: theme.spacing(shellMetrics.cardPadding / 8),
    '& a': {
      overflowWrap: 'anywhere',
      wordBreak: 'break-word',
    },
    '&:last-child': {
      paddingBottom: theme.spacing(shellMetrics.cardPadding / 8),
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
      '&:last-child': {
        paddingBottom: theme.spacing(2),
      },
    },
  },
});
